import { Box, Grid } from "@mui/material";
import { BoxMotion, TypographyMotion } from "components/elements/material_motion";
import ProjectCard from "components/elements/project_card";
import { firebaseDatabase } from "config/firebase";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NAVIGATION_SET_MENU } from "utils/redux/action";

export default function ProjectListPage() {
  const dispatcher = useDispatch();
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    dispatcher({ type: NAVIGATION_SET_MENU, index: 3 });
  }, [dispatcher]);

  useEffect(() => {
    const listenerProjects = onSnapshot(
      query(collection(firebaseDatabase, "projects"), orderBy("name")),
      (_) => setProjects(_.docs.map((_) => ({ id: _.id, ..._.data() })))
    );

    return () => listenerProjects();
  }, []);

  return (
    <Box sx={{ position: "relative", padding: { xs: 0, sm: "0 10px" } }}>
      <TypographyMotion
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: "spring", delay: 0.0, duration: 1 }}
        variant="h2"
        sx={{
          fontFamily: "Poppins",
          fontWeight: 700,
          fontSize: { xs: 20, md: 24 },
          color: "black",
          margin: 0,
        }}
      >
        Projek Yang Pernah Dikerjakan
      </TypographyMotion>
      <Grid
        container
        spacing={5}
        sx={{
          padding: "0 8px",
          marginTop: 3,
        }}
      >
        {projects.map((_, __) => (
          <Grid key={__} item xs={12} sm={6} md={4} lg={3}>
            <BoxMotion
              key={__}
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ type: "spring", delay: 0.1 * __, duration: 1 }}
            >
              <ProjectCard index={{__}} data={_} />
            </BoxMotion>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
